<div class="project-history-container">
  <p-toast></p-toast>

  <p-confirmDialog></p-confirmDialog>

  <div class="dashboard-content">
    <!-- Header simple et professionnel -->
    <div class="dashboard-header">
      <div class="header-content">
        <div class="header-title-block">
          <h1>Historique des Projets</h1>
        </div>

        <div class="user-status-summary" *ngIf="userStatusCounts.length > 0">
          <div class="user-status-card" *ngFor="let counts of userStatusCounts">
            <div class="user-status-name">{{ getUserStatusDisplayName(counts) }}</div>
            <div class="user-status-total">{{ counts.total_projects }} projet(s)</div>
            <div class="user-status-counts">
              <span class="user-status-pill pending">{{ counts.a_traiter_count }} Nouveau</span>
              <span class="user-status-pill done">{{ counts.traite_count }} En cours</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Actions -->
    <p-card styleClass="actions-card">
      <ng-template pTemplate="content">
        <div class="actions-bar">
          <div class="search-section">
            <span class="p-input-icon-left">
              <i class="pi pi-search"></i>
              <input pInputText type="text" [(ngModel)]="searchTerm"
                placeholder="Rechercher un projet, email ou téléphone..." (ngModelChange)="onSearchChange($event)" />
            </span>
          </div>

          <div class="filters-section">
            <div class="filters-row">
              <p-dropdown [options]="typeProjetFilter" [(ngModel)]="selectedTypeProjet" placeholder="Type de projet"
                (onChange)="onTypeProjetChange()" [showClear]="true"></p-dropdown>

              <p-dropdown [options]="origineFilter" [(ngModel)]="selectedOrigine" placeholder="Origine"
                (onChange)="onOrigineChange()" [showClear]="true"></p-dropdown>

              <p-dropdown [options]="statusFilter" [(ngModel)]="selectedStatus" placeholder="Statut"
                (onChange)="onStatusChange()" [showClear]="true"></p-dropdown>

              <p-dropdown [options]="emailValidityFilter" [(ngModel)]="selectedEmailValidity"
                placeholder="Validité email" (onChange)="onEmailValidityChange()" [showClear]="true"
                optionLabel="label" optionValue="value"></p-dropdown>

              <p-dropdown [options]="cotisationLevelFilter" [(ngModel)]="selectedCotisationLevel"
                placeholder="Cotisation" (onChange)="onCotisationLevelChange()" [showClear]="true"
                optionLabel="label" optionValue="value"></p-dropdown>

              <p-dropdown [options]="usersFilter" [(ngModel)]="selectedUserId" placeholder="Utilisateur"
                (onChange)="onUserChange()" [showClear]="true" optionLabel="label" optionValue="value"></p-dropdown>

              <p-calendar [(ngModel)]="dateRange" selectionMode="range" [readonlyInput]="false"
                placeholder="Date de création" dateFormat="dd/mm/yy" (ngModelChange)="onDateRangeChange()"
                (onClearClick)="onDateRangeChange()" [showIcon]="true" [showClear]="true" [numberOfMonths]="2">
              </p-calendar>
            </div>
          </div>

          <div class="toolbar-action-buttons">
            <input *ngIf="isAdmin" #csvImportInput type="file" accept=".csv,.txt" class="hidden-file-input"
              (change)="onCsvFileSelected($event)">

            <input *ngIf="isAdmin" #mobileDeleteExcelInput type="file" accept=".xlsx,.xlsm" class="hidden-file-input"
              (change)="onMobileDeleteExcelSelected($event)">

            <div class="action-execute-group">
              <p-dropdown [options]="actionMenuOptions" [(ngModel)]="selectedAction" optionLabel="label"
                optionValue="value" placeholder="Choisir une action" [showClear]="true"
                (onChange)="onActionMenuChange()">
              </p-dropdown>

              <p-dropdown *ngIf="selectedAction === 'change_status'" [options]="statusFilter"
                [(ngModel)]="selectedBulkStatus" optionLabel="label" optionValue="value" placeholder="Nouveau statut"
                [showClear]="true" [disabled]="allTableSelected || updatingStatus || loading">
              </p-dropdown>

              <p-button label="Exécuter" icon="pi pi-play" (onClick)="executeSelectedAction()"
                [disabled]="!canExecuteSelectedAction()" [loading]="isExecutingSelectedAction()"
                styleClass="p-button-primary" pTooltip="Exécuter l'action sélectionnée"></p-button>
            </div>

            <div class="toolbar-utility-buttons">
              <p-button icon="pi pi-times" (onClick)="clearSearch()" [disabled]="!hasActiveFilters()"
                styleClass="p-button-secondary" pTooltip="Effacer tous les filtres"></p-button>

              <p-button icon="pi pi-plus" (onClick)="createNewProject()" styleClass="p-button-success"
                pTooltip="Nouveau projet"></p-button>

              <p-button icon="pi pi-refresh" (onClick)="refresh()" [loading]="loading" pTooltip="Actualiser"></p-button>
            </div>
          </div>
        </div>
      </ng-template>
    </p-card>

    <!-- Message de filtres actifs -->
    <div *ngIf="hasActiveFilters() && getSearchMessageDetail()" class="active-filters-banner">
      <div class="active-filters-banner-content">
        <i class="pi pi-info-circle"></i>
        <span>{{ getSearchMessageDetail() }}</span>
      </div>
      <button type="button" class="active-filters-clear-btn" (click)="clearSearch()" aria-label="Supprimer les filtres"
        pTooltip="Supprimer tous les filtres">
        <i class="pi pi-times"></i>
      </button>
    </div>

    <!-- Barre de sélection -->
    <div class="selection-bar" *ngIf="selectedProjects.length > 0 || allTableSelected">
      <div class="selection-info">
        <i class="pi pi-check-circle"></i>
        <span>{{ getSelectedProjectsCount() }} projet(s) sélectionné(s)</span>
      </div>
      <div class="selection-actions">
        <p-button *ngIf="canSelectEntireTable()" label="Sélectionner tout le tableau" icon="pi pi-list-check"
          (onClick)="selectEntireTable()" styleClass="p-button-secondary p-button-sm"></p-button>
        <p-button label="Désélectionner" icon="pi pi-times" (onClick)="clearSelection()"
          styleClass="p-button-text p-button-sm"></p-button>
      </div>
    </div>

    <!-- Table -->
    <div class="table-container">
      <p-table [value]="filteredProjects" [loading]="loading" [paginator]="true" [lazy]="true" [lazyLoadOnInit]="false"
        [totalRecords]="totalRecords" [rows]="rows" [first]="first" [rowsPerPageOptions]="[5,10,100]"
        [paginatorDropdownAppendTo]="'body'" (onLazyLoad)="onPageChange($event)" [showCurrentPageReport]="true"
        [currentPageReportTemplate]="hasActiveFilters() ? 
                 'Affichage de {first} à {last} sur {totalRecords} résultats de recherche' : 
                 'Affichage de {first} à {last} sur {totalRecords} projets'" responsiveLayout="scroll"
        dataKey="project_id">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 3rem">
              <p-checkbox [binary]="true" [ngModel]="areAllVisibleSelected()"
                [indeterminate]="areSomeVisibleSelected() && !areAllVisibleSelected()"
                [disabled]="!hasSelectableVisibleProjects()" (onChange)="toggleAllSelection($event)"
                pTooltip="Sélectionner tout">
              </p-checkbox>
            </th>
            <th>Client</th>
            <th>Projet</th>
            <th>Statut</th>
            <th>Phase</th>
            <th>Résultat d'appel</th>
            <th>Financement</th>
            <th>Cotisation</th>
            <th>Banque</th>
            <th>Créé le</th>
            <th>Actions</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-project let-rowIndex="rowIndex">
          <tr [class.selected-row]="isProjectSelected(project)"
            [class.invalid-email-row]="isProjectEmailInvalid(project)">
            <td>
              <p-checkbox [binary]="true" [ngModel]="isProjectSelected(project)" [disabled]="!canSelectProject(project)"
                (onChange)="toggleProjectSelection(project, $event)">
              </p-checkbox>
            </td>
            <td>
              <div class="client-info">
                <div class="client-avatar"
                  [class]="project.type_souscripteur === 'Personne morale' ? 'company' : 'person'">
                  {{ getClientInitials(project) }}
                </div>
                <div class="client-details-text">
                  <div class="client-name">{{ project.raison_sociale || (project.prenom + ' ' + project.nom) }}</div>
                  <div class="client-email" *ngIf="project.email">
                    <a [href]="'mailto:' + project.email" class="email-link">{{ project.email }}</a>
                  </div>
                  <div class="email-validation-invalid" *ngIf="isProjectEmailInvalid(project)">
                    <i class="pi pi-times-circle"></i>
                    <span>Email non valide</span>
                  </div>
                  <div class="client-type" *ngIf="project.est_co_emprunteur">
                    <i class="pi pi-users"></i> Co-emprunteur
                  </div>
                  <div class="client-badge-row" *ngIf="isAdmin">
                    <p-tag [value]="getClientBadgeLabel(project)" [severity]="getClientBadgeSeverity(project)"
                      styleClass="client-badge-tag" [rounded]="true">
                    </p-tag>
                  </div>
                </div>
              </div>
            </td>
            <td>
              <div class="project-info-cell">
                <div class="project-type-tags">
                  <p-tag *ngIf="getProjectTypeDisplay(project)" [value]="getProjectTypeDisplay(project)"
                    [severity]="getProjectTypeColor(project.type_projet)" [rounded]="true">
                  </p-tag>
                  <p-tag [value]="getOrigineLabel(project.origine)" [severity]="getOrigineColor(project.origine)"
                    [rounded]="true">
                  </p-tag>
                </div>
                <div class="project-subinfo">
                  <span *ngIf="shouldShowProjectName(project)" class="project-name-text">{{ project.nom_projet }}</span>
                  <span *ngIf="project.type_pret" class="project-pret-type">{{ project.type_pret }}</span>
                </div>
                <div class="project-id-small">
                  <span>{{ project.project_id }}</span>
                  <span *ngIf="project.projet_source_id" class="source-link">
                    <i class="pi pi-arrow-up-right"></i> {{ project.projet_source_id }}
                  </span>
                </div>
              </div>
            </td>
            <td>
              <p-tag [value]="getStatusLabel(project.status)" [severity]="getStatusColor(project.status)"
                [styleClass]="'status-chip ' + getStatusClass(project.status)" [rounded]="true">
              </p-tag>
            </td>
            <td>
              <p-tag [value]="project.phase || '—'" [severity]="getPhaseSeverity(project.phase)"
                styleClass="status-chip" [rounded]="true">
              </p-tag>
            </td>
            <td>
              <div style="display:flex;flex-direction:column;gap:4px;align-items:flex-start">
                <p-tag [value]="getResultatAppelLabel(project.resultat_appel)"
                  [severity]="getResultatAppelSeverity(project.resultat_appel)" styleClass="status-chip" [rounded]="true">
                </p-tag>
                <p-dropdown
                  [options]="resultatAppelOptions"
                  [ngModel]="project.resultat_appel || null"
                  (onChange)="onResultatAppelChange(project, $event.value)"
                  [showClear]="!!project.resultat_appel" placeholder="Changer…"
                  [disabled]="savingResultatAppelProjectId === project.project_id"
                  appendTo="body" [style]="{ minWidth:'105px', fontSize:'.8rem' }">
                </p-dropdown>
              </div>
            </td>
            <td>
              <div class="finance-cell" *ngIf="getProjectLoanLines(project) as loans">
                <div class="finance-loan" *ngFor="let loan of loans">
                  <div class="finance-loan-label" *ngIf="loan.label">{{ loan.label }}</div>
                  <div class="amount-display">
                    {{ loan.amount !== null && loan.amount !== undefined ? (formatAmount(loan.amount) + ' €') : '-' }}
                  </div>
                  <div class="finance-details">
                    <span *ngIf="loan.duration !== null && loan.duration !== undefined">{{ loan.duration }} mois</span>
                    <span *ngIf="loan.rate !== null && loan.rate !== undefined" class="rate-info">{{ loan.rate
                      }}%</span>
                  </div>
                </div>
              </div>
            </td>
            <td>
              <div
                *ngIf="project.tarif_mensuel_moins_cher !== null && project.tarif_mensuel_moins_cher !== undefined; else noCotisation"
                class="cotisation-cell">
                <div class="cotisation-monthly">{{ formatCotisationAmount(project.tarif_mensuel_moins_cher) }}€</div>
                <div class="cotisation-monthly-caption">mois</div>
                <div class="cotisation-total"
                  *ngIf="project.cotisation_totale_moins_chere !== null && project.cotisation_totale_moins_chere !== undefined">
                  {{ formatCotisationAmount(project.cotisation_totale_moins_chere) }}€
                </div>
                <div class="cotisation-assureur" *ngIf="project.assureur_moins_cher">
                  <i class="pi pi-shield"></i>
                  <span>{{ project.assureur_moins_cher }}</span>
                </div>
              </div>
              <ng-template #noCotisation>
                <span class="text-muted">-</span>
              </ng-template>
            </td>
            <td>
              <span *ngIf="project.banque; else noBanque" class="bank-name-cell">
                <i class="pi pi-building"></i>
                {{ getBanqueLabel(project.banque) }}
              </span>
              <ng-template #noBanque>
                <span class="text-muted">-</span>
              </ng-template>
            </td>
            <td>
              <span class="created-date">{{ formatDate(project.created_at) }}</span>
            </td>
            <td>
              <div class="row-action-buttons-wrap">
                <div class="row-action-buttons">
                  <p-button icon="pi pi-upload" pTooltip="Charger" (onClick)="loadProject(project)"
                    [disabled]="loading || !canOpenProject(project)"
                    styleClass="p-button-text p-button-success"></p-button>
                  <p-button icon="pi pi-copy" pTooltip="Dupliquer" (onClick)="duplicateProject(project)"
                    [disabled]="loading || !canOpenProject(project)"
                    styleClass="p-button-text p-button-warning"></p-button>
                  <p-button icon="pi pi-eye" pTooltip="Voir" (onClick)="viewProjectDetails(project)"
                    [disabled]="loading || !canOpenProject(project)" styleClass="p-button-text p-button-info"></p-button>
                  <p-button icon="pi pi-sync" pTooltip="Ouvrir la transaction associée"
                    (onClick)="openTransaction(project)" [disabled]="loading || !canOpenProject(project)"
                    styleClass="p-button-text p-button-help"></p-button>
                  <p-button icon="pi pi-comment"
                    pTooltip="Commentaire"
                    (onClick)="openComment(project)"
                    [styleClass]="project.commentaire ? 'p-button-text btn-comment has-comment' : 'p-button-text btn-comment'"></p-button>
                  <p-button icon="pi pi-trash" pTooltip="Supprimer" (onClick)="deleteProject(project)"
                    [disabled]="loading || !canDeleteProject(project)"
                    styleClass="p-button-text p-button-danger"></p-button>
                </div>
                <!-- Ringover : ligne en dessous -->
                <ng-container *ngIf="projectPhoneE164(project) as phone">
                  <app-ringover-click-to-call
                    [phoneNumber]="phone"
                    [displayName]="projectDisplayName(project)"
                    [projectId]="project.project_id">
                  </app-ringover-click-to-call>
                </ng-container>
              </div>
            </td>
          </tr>
        </ng-template>


        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="11">
              <div class="empty-state">
                <i class="pi pi-folder-open"></i>
                <h3>Aucun projet trouvé</h3>
                <p *ngIf="!hasActiveFilters()">Commencez par créer votre premier projet</p>
                <p *ngIf="hasActiveFilters()">Aucun projet ne correspond aux filtres sélectionnés</p>
                <p-button *ngIf="!hasActiveFilters()" label="Créer un projet" icon="pi pi-plus"
                  (onClick)="createNewProject()" styleClass="p-button-success"></p-button>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<!-- Dialog commentaire (Transaction.commentaire) -->
<p-dialog header="Commentaire" [(visible)]="commentDialogVisible" [modal]="true" [draggable]="false"
  [resizable]="false" [style]="{width: '520px', maxWidth: '95vw'}">
  <div style="display:flex;flex-direction:column;gap:8px">
    <div style="font-size:12px;color:#888">{{ commentDialogTitle }}</div>
    <textarea [(ngModel)]="commentDialogText" rows="8"
      style="width:100%;box-sizing:border-box;resize:vertical;border:1px solid #cfd8dc;border-radius:8px;padding:8px;font:inherit"
      placeholder="Ce qu'on a fait avec ce contact…"></textarea>
    <div style="font-size:12px;color:#888">
      <i class="pi pi-info-circle"></i>
      Commentaire partagé avec la table transactions et l'agenda.
    </div>
  </div>
  <ng-template pTemplate="footer">
    <p-button label="Fermer" icon="pi pi-times" styleClass="p-button-text p-button-secondary"
      [disabled]="savingComment" (onClick)="commentDialogVisible = false"></p-button>
    <p-button label="Enregistrer" icon="pi pi-check" [loading]="savingComment"
      [disabled]="savingComment || !commentDialogProjectId" (onClick)="saveComment()"></p-button>
  </ng-template>
</p-dialog>

<!-- Dialog d'attribution de projets -->
<p-dialog header="Attribuer des Projets" [(visible)]="showAssignmentDialog" [modal]="true" [style]="{width: '600px'}"
  [closable]="true" styleClass="assignment-dialog">
  <ng-template pTemplate="content">
    <div class="assignment-content">

      <!-- Projets sélectionnés -->
      <div class="selected-projects-section">
        <h4><i class="pi pi-list"></i> Projets à attribuer ({{ selectedProjects.length }})</h4>
        <div class="selected-projects-list">
          <div *ngFor="let project of selectedProjects" class="selected-project-item">
            <div class="project-info">
              <span class="project-id">{{ project.project_id }}</span>
              <span class="project-client">
                {{ project.raison_sociale || (project.prenom + ' ' + project.nom) }}
              </span>
              <span class="project-amount">{{ formatAmount(project.montant) }}€</span>
            </div>
            <p-button icon="pi pi-times" (onClick)="removeFromSelection(project)"
              styleClass="p-button-text p-button-sm p-button-danger" pTooltip="Retirer de la sélection">
            </p-button>
          </div>
        </div>
      </div>

      <!-- Sélection utilisateur -->
      <div class="user-selection-section">
        <h4><i class="pi pi-user"></i> Utilisateur destinataire</h4>
        <div class="field">
          <label for="targetUser">Sélectionner un utilisateur *</label>
          <p-dropdown [options]="activeUsers" [(ngModel)]="selectedTargetUser" optionLabel="full_name"
            placeholder="Choisir un utilisateur..." id="targetUser" [style]="{'width': '100%'}" [showClear]="true">
            <ng-template pTemplate="selectedItem">
              <div *ngIf="selectedTargetUser" class="selected-user">
                <i class="pi pi-user"></i>
                <span>{{ getAssigneeDisplayLabel(selectedTargetUser) }}</span>
                <small>({{ selectedTargetUser.project_count }} projets)</small>
              </div>
            </ng-template>
            <ng-template pTemplate="item" let-user>
              <div class="user-option">
                <div class="user-info">
                  <span class="user-email">{{ getAssigneeDisplayLabel(user) }}</span>
                  <small class="user-stats" *ngIf="isCurrentAdminAssignee(user)">Compte connecté</small>
                  <small class="user-stats">{{ user.project_count }} projets</small>
                </div>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
      </div>

      <!-- Options d'attribution -->
      <div class="assignment-options">
        <h4><i class="pi pi-cog"></i> Options</h4>

        <div class="field-checkbox">
          <p-checkbox [(ngModel)]="keepCopy" binary="true" inputId="keepCopy">
          </p-checkbox>
          <label for="keepCopy">
            Conserver une copie pour moi
            <small>Si coché, les projets seront copiés au lieu d'être transférés</small>
          </label>
        </div>

        <div class="field">
          <label for="assignmentReason">Motif d'attribution (optionnel)</label>
          <input pInputText id="assignmentReason" [(ngModel)]="assignmentReason"
            placeholder="Ex: Transfert de dossier client..." [style]="{'width': '100%'}">
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="assignment-footer">
      <p-button label="Annuler" icon="pi pi-times" (onClick)="closeAssignmentDialog()"
        styleClass="p-button-text"></p-button>

      <p-button [label]="keepCopy ? 'Copier les projets' : 'Transférer les projets'"
        [icon]="keepCopy ? 'pi pi-copy' : 'pi pi-arrow-right'" (onClick)="assignProjects()"
        [disabled]="!selectedTargetUser || assigningProjects" [loading]="assigningProjects"
        [styleClass]="keepCopy ? 'p-button-warning' : 'p-button-success'">
      </p-button>
    </div>
  </ng-template>
</p-dialog>

<!-- Dialog de détails du projet -->
<p-dialog [(visible)]="showProjectDetailDialog" [modal]="true" [style]="{width: '700px'}" [closable]="true"
  [draggable]="false" [resizable]="false" styleClass="project-detail-dialog">
  <ng-template pTemplate="header">
    <div style="display: flex; align-items: center; gap: 10px;">
      <i class="pi pi-folder-open" style="font-size: 1.3rem; color: white;"></i>
      <div>
        <h3 style="margin: 0; font-size: 1.1rem; color: white;">Détails du Projet</h3>
        <p style="margin: 2px 0 0 0; font-size: 0.8rem; color: rgba(255,255,255,0.8);" *ngIf="selectedProjectDetails">
          {{ selectedProjectDetails.project_id }}
        </p>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="content">
    <div *ngIf="loadingDetails" class="project-detail-loading">
      <p-progressSpinner strokeWidth="4"></p-progressSpinner>
      <p>Chargement des détails du projet...</p>
    </div>

    <div *ngIf="!loadingDetails && selectedProjectDetails" class="project-detail-simple">

      <!-- Tags en haut -->
      <div class="detail-tags-row">
        <p-tag [value]="getProjectTypeLabel(selectedProjectDetails.type_projet || '')"
          [severity]="getProjectTypeColor(selectedProjectDetails.type_projet || '')" [rounded]="true"></p-tag>
        <p-tag [value]="getOrigineLabel(selectedProjectDetails.origine || '')"
          [severity]="getOrigineColor(selectedProjectDetails.origine || '')" [rounded]="true"></p-tag>
        <p-tag *ngIf="selectedProjectDetails.est_co_emprunteur" value="Co-emprunteur" severity="info"
          [rounded]="true"></p-tag>
      </div>

      <!-- Montant principal -->
      <div class="detail-amount-banner">
        <span class="detail-amount-value">{{ formatAmount(selectedProjectDetails.montant || 0) }} €</span>
        <span class="detail-amount-sub">
          {{ selectedProjectDetails.duree }} mois
          <span *ngIf="selectedProjectDetails.taux"> &middot; {{ selectedProjectDetails.taux }}%</span>
        </span>
      </div>

      <!-- Grille d'infos -->
      <div class="detail-info-grid">
        <div class="detail-info-item" *ngIf="selectedProjectDetails.raison_sociale">
          <span class="detail-info-label">Raison sociale</span>
          <span class="detail-info-value">{{ selectedProjectDetails.raison_sociale }}</span>
        </div>
        <div class="detail-info-item"
          *ngIf="!selectedProjectDetails.raison_sociale && (selectedProjectDetails.prenom || selectedProjectDetails.nom)">
          <span class="detail-info-label">Client</span>
          <span class="detail-info-value">{{ selectedProjectDetails.prenom }} {{ selectedProjectDetails.nom }}</span>
        </div>
        <div class="detail-info-item" *ngIf="selectedProjectDetails.email">
          <span class="detail-info-label">Email</span>
          <a [href]="'mailto:' + selectedProjectDetails.email" class="detail-info-link">{{ selectedProjectDetails.email
            }}</a>
        </div>
        <div class="detail-info-item" *ngIf="selectedProjectDetails.type_pret">
          <span class="detail-info-label">Type de prêt</span>
          <span class="detail-info-value">{{ selectedProjectDetails.type_pret }}</span>
        </div>
        <div class="detail-info-item" *ngIf="selectedProjectDetails.banque">
          <span class="detail-info-label">Banque</span>
          <span class="detail-info-value">{{ getBanqueLabel(selectedProjectDetails.banque) }}</span>
        </div>
        <div class="detail-info-item" *ngIf="selectedProjectDetails.est_co_emprunteur">
          <span class="detail-info-label">Co-emprunteur</span>
          <span class="detail-info-value">{{ selectedProjectDetails.co_emprunteur_prenom }} {{
            selectedProjectDetails.co_emprunteur_nom }}</span>
        </div>
        <div class="detail-info-item" *ngIf="selectedProjectDetails.nom_projet">
          <span class="detail-info-label">Nom du projet</span>
          <span class="detail-info-value">{{ selectedProjectDetails.nom_projet }}</span>
        </div>
        <div class="detail-info-item">
          <span class="detail-info-label">ID</span>
          <span class="detail-info-value mono">{{ selectedProjectDetails.id }}</span>
        </div>
        <div class="detail-info-item">
          <span class="detail-info-label">Créé le</span>
          <span class="detail-info-value">{{ formatDate(selectedProjectDetails.created_at) }}</span>
        </div>
        <div class="detail-info-item" *ngIf="selectedProjectDetails.projet_source_id">
          <span class="detail-info-label">Projet source</span>
          <a class="detail-info-link" (click)="viewSourceProject(selectedProjectDetails.projet_source_id!)"
            style="cursor:pointer;">
            {{ selectedProjectDetails.projet_source_id }}
          </a>
        </div>
      </div>

      <div class="detail-all-section">
        <h4>Toutes Les Informations</h4>
        <div class="detail-all-grid">
          <div class="detail-all-item" *ngFor="let entry of getAllProjectDetailsEntries()">
            <span class="detail-all-label">{{ formatDetailLabel(entry.key) }}</span>
            <pre class="detail-all-value">{{ formatDetailValue(entry.key, entry.value) }}</pre>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="dialog-footer-pro">
      <p-button label="Fermer" icon="pi pi-times" (onClick)="closeProjectDetailDialog()"
        styleClass="p-button-text p-button-secondary"></p-button>

      <div class="footer-actions">
        <p-button label="Charger" icon="pi pi-upload" (onClick)="loadProjectFromDialog()" [loading]="loading"
          [disabled]="loading || !canOpenProject(selectedProjectDetails)" styleClass="p-button-success"
          pTooltip="Charger dans le formulaire"></p-button>

        <p-button label="Dupliquer" icon="pi pi-copy" (onClick)="duplicateProjectFromDialog()" [loading]="loading"
          [disabled]="loading || !canOpenProject(selectedProjectDetails)" styleClass="p-button-warning"></p-button>

        <p-button icon="pi pi-trash" (onClick)="deleteProjectFromDialog()" [loading]="loading"
          [disabled]="loading || !canDeleteProject(selectedProjectDetails)"
          styleClass="p-button-danger p-button-outlined" pTooltip="Supprimer"></p-button>
      </div>
    </div>
  </ng-template>
</p-dialog>